// extracted by mini-css-extract-plugin
export default {"root":"checkbox_root__-PqgR","input":"checkbox_input__JKud5"};